export default __webpack_public_path__ + "static/media/Background.31ee366e.png";